module.exports = __webpack_public_path__ + "static/media/qid.6ee2d90f.png";